export const CALCULATE_LINE_ITEM_SUCCESS = 'CALCULATE_LINE_ITEM_SUCCESS'
export const CALCULATE_LINE_ITEM_REQUEST = 'CALCULATE_LINE_ITEM_REQUEST'
export const CALCULATE_LINE_ITEM_FAILURE = 'CALCULATE_LINE_ITEM_FAILURE'
